/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TrialPromoService {
    /**
     * Apply Trial Promo
     * Add 7 more free days and stripe coupon using the provided token and return the payment session URL.
     * @returns string Successfully applied trial promo
     * @throws ApiError
     */
    public static applyTrialPromo({
        token,
    }: {
        token: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/trial-promo/apply',
            query: {
                'token': token,
            },
        });
    }
}
